<div class="ir-area ir-mask th-mask ir-pluginedit-totaltimetorepair">
  <form class="ir-modal th-modal" novalidate (ngSubmit)="save(editForm.value)" [formGroup]="editForm">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <h2>
          <span>{{ 'plugins.total-time-to-repair.total-estimated-time' | translate }}</span>
        </h2>
        <p>
          <span *ngFor="let item of sumTimeToRepairs" style="display: block">
            <strong class="ir-ph1">{{ item?.Hours | number : '2.0' }}:{{ item?.Minutes | number : '2.0' }} </strong>
            {{ 'plugins.total-time-to-repair.hours' | translate }} hours
            {{ 'plugins.total-time-to-repair.by' | translate }}
            <strong class="ir-ph1">{{ item?.Reparator | reparatorpipe }}</strong>
          </span>
        </p>
        <h2>
          <span>{{ 'plugins.total-time-to-repair.repair-will-take' | translate }} :</span>
        </h2>
        <table class="ir-plugin-table">
          <tr class="th-plugin-line--subheader">
            <td>
              <span>{{ 'plugins.total-time-to-repair.days' | translate }}</span>
            </td>
            <td colspan="2">
              <span>{{ 'plugins.total-time-to-repair.perfomed-by' | translate }} :</span>
            </td>
          </tr>
          <tr
            class="th-plugin-line--input"
            formArrayName="totaltimetorepairs"
            *ngFor="let item of formData.controls; let i = index"
          >
            <td style="width: 20%" [formGroupName]="i">
              <div class="ir-form-group margin">
                <input formControlName="Days" placeholder="0" class="ir-form-set" type="number" min="0" />
              </div>
            </td>
            <td style="width: 15%" [formGroupName]="i">
              <div class="ir-form-group margin">
                <input formControlName="Count" placeholder="0" class="ir-form-set" type="number" min="0" />
              </div>
            </td>
            <td class="th-plugin-line--value" [formGroupName]="i">
              <p
                class="ir-required th-required"
                [class.visible]="!(item.controls.Reparator.value || item.controls.Reparator.value === 0)"
              >
                <span>{{ 'common.required' | translate }}</span>
              </p>
              <input type="hidden" class="ir-form-set" formControlName="Reparator" />
              <div
                class="ir-line ir-select th-select"
                (click)="openReparatorSelector(item.controls.Reparator.value, i)"
              >
                <div class="ir-line--right">
                  <div class="ir-btn th-btn-modal--content">
                    <i class="material-icons">arrow_drop_down</i>
                  </div>
                </div>
                <div class="ir-line-content">
                  <span>{{
                    item.controls.Reparator.value || item.controls.Reparator.value === 0
                      ? (item.controls.Reparator.value | reparatorpipe)
                      : ('plugins.total-time-to-repair.select-people' | translate)
                  }}</span>
                </div>
              </div>
            </td>
            <td style="width: 10%" class="th-plugin-line--remove">
              <i class="material-icons" (click)="remove(i)">remove_circle</i>
            </td>
          </tr>
          <tr class="th-plugin-line--add">
            <td colspan="4">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="!editForm.valid"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<modal (modalOutput)="selectReparatorMenu($event)" #reparatorModal></modal>
<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
